import { observer } from "mobx-react";
import * as React from "react";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";

export const NoResults = observer(() => (
    <EmptyState
        image={THEME.Images.illuNoResults}
        title={t("error.noApplicants.header")}
        text={t("error.noApplicants")}
    />
));

export const NoNotes = observer(() => (
    <EmptyState image={THEME.Images.illuNoNotes} title={t("error.noNotes.header")} text={t("error.noNotes")} />
));

type Props = {
    image: string;
    title: string;
    text: string;
};

const EmptyState = ({ image, title, text }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <div
            style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 100
            }}
        >
            <img src={image} alt="" style={{ maxWidth: "100%" }} />
            <div style={{ display: "flex", gap: 16, flexDirection: "column" }}>
                <h3>{title}</h3>
                <p>{text}</p>
            </div>
        </div>
    );
};
